var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAuthenticatorMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 12L11.5 14L14.7 10M13.6 20.7C12.6 21.1 11.4 21.2 10.4 20.7C7.7 19.6 3.9 16.8 3.5 12C3 5.5 3 6 3 6L12 3L21 6C21 6 21 5.5 20.5 12C20.2 16.5 16.3 19.5 13.6 20.7Z",
    stroke: "#111827",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthenticatorMenu);
export default __webpack_public_path__ + "static/media/icon-authenticator-menu.c665578ae6e8e2cc10cca327f32da93b.svg";
export { ForwardRef as ReactComponent };